{
  "dismiss": "Ignora"
}